module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Agregar una Empresa",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": function($event) {}
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Nombre de la compañia"
    },
    model: {
      value: (_vm.companyNew.nombre),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "nombre", $$v)
      },
      expression: "companyNew.nombre"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "Razon Social",
      "required": "",
      "placeholder": "Razón Social"
    },
    model: {
      value: (_vm.companyNew.razonSocial),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "razonSocial", $$v)
      },
      expression: "companyNew.razonSocial"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("CUIT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "CUIT"
    },
    model: {
      value: (_vm.companyNew.cuit),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "cuit", $$v)
      },
      expression: "companyNew.cuit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Rubros")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-select', {
    attrs: {
      "required": "",
      "multiple": "",
      "placeholder": "Seleccionar Rubro"
    },
    model: {
      value: (_vm.currentIdRubro),
      callback: function($$v) {
        _vm.currentIdRubro = $$v
      },
      expression: "currentIdRubro"
    }
  }, _vm._l((_vm.rubros), function(item) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "value": item.idRubro,
        "label": item.nombre
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Comentarios sobre la Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.companyNew.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "descripcion", $$v)
      },
      expression: "companyNew.descripcion"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveCompany()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("Cancelar")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Detalle",
      "visible": _vm.showModalDetails,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDetails = $event
      },
      "close": function($event) {
        this.currentIdRubro = []
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap",
      "gap": "1rem",
      "margin-bottom": "1rem"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(0, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos generales")]), _vm._v(" "), (_vm.currentCompany.codCountry === 'AR') ? _c('el-button', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(1, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos bancarios")]) : _vm._e(), _vm._v(" "), (_vm.currentCompany.codCountry === 'PE') ? _c('el-button', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(2, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos bancarios")]) : _vm._e(), _vm._v(" "), (_vm.currentCompany.codCountry === 'AR') ? _c('el-button', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(2, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos impositivos")]) : _vm._e(), _vm._v(" "), (_vm.currentCompany.codCountry === 'PE') ? _c('el-button', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(1, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos impositivos")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Nombre")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.currentCompany.company
    },
    model: {
      value: (_vm.currentCompany.company),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "company", $$v)
      },
      expression: "currentCompany.company"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "placeholder": _vm.currentCompany.company
    },
    model: {
      value: (_vm.currentCompany.company),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "company", $$v)
      },
      expression: "currentCompany.company"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.currentCompany.companyName,
      "min-width": "1"
    },
    model: {
      value: (_vm.currentCompany.companyName),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "companyName", $$v)
      },
      expression: "currentCompany.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "placeholder": _vm.currentCompany.companyName
    },
    model: {
      value: (_vm.currentCompany.companyName),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "companyName", $$v)
      },
      expression: "currentCompany.companyName"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("ID FISCAL")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.currentCompany.cuit
    },
    model: {
      value: (_vm.currentCompany.cuit),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "cuit", $$v)
      },
      expression: "currentCompany.cuit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "placeholder": _vm.currentCompany.cuit
    },
    model: {
      value: (_vm.currentCompany.cuit),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "cuit", $$v)
      },
      expression: "currentCompany.cuit"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Comentarios sobre la Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.currentCompany.reasonCalification),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "reasonCalification", $$v)
      },
      expression: "currentCompany.reasonCalification"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Comentarios sobre la Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": "",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.currentCompany.reasonCalification),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "reasonCalification", $$v)
      },
      expression: "currentCompany.reasonCalification"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Información Adicional:")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "required": "",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5,
      "placeholder": _vm.currentCompany.comments
    },
    model: {
      value: (_vm.currentCompany.comments),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "comments", $$v)
      },
      expression: "currentCompany.comments"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": "",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5,
      "required": "",
      "placeholder": _vm.currentCompany.comments
    },
    model: {
      value: (_vm.currentCompany.comments),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "comments", $$v)
      },
      expression: "currentCompany.comments"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateCompany()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        (_vm.showModalDetails = false), _vm.$parent.getProviders()
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")])])]), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Agregar  Comentario",
      "visible": _vm.showModalComment,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalComment = $event
      },
      "close": function($event) {}
    }
  }, [_c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateCalification(_vm.company, 'true')
      }
    }
  }, [_vm._v("\n          Guardar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalComment()
      }
    }
  }, [_vm._v("Cancelar")])])])], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Agregar  Comentario",
      "visible": _vm.showModalComment,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalComment = $event
      },
      "close": function($event) {}
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Calificación")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-rate', {
    staticStyle: {
      "float": "left"
    },
    model: {
      value: (_vm.company.calification),
      callback: function($$v) {
        _vm.$set(_vm.company, "calification", $$v)
      },
      expression: "company.calification"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-3"
  }, [_c('label', [_vm._v("Descripción de La Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "show-word-limit": "",
      "maxlength": "256",
      "rows": 5
    },
    model: {
      value: (_vm.company.reasonCalification),
      callback: function($$v) {
        _vm.$set(_vm.company, "reasonCalification", $$v)
      },
      expression: "company.reasonCalification"
    }
  }, [_vm._v(_vm._s(_vm.company.reasonCalification))])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateCalification(_vm.company, 'true')
      }
    }
  }, [_vm._v("\n          Guardar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalComment()
      }
    }
  }, [_vm._v("Cancelar")])])])], 1), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    staticClass: "provider__modal-mobile",
    attrs: {
      "title": 'Documentación de ' + _vm.company.companyName,
      "visible": _vm.showModalDocumentation,
      "width": "40%",
      "lock-scroll": true,
      "before-close": _vm.closeDocumentation
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDocumentation = $event
      }
    }
  }, [_vm._l((_vm.documents), function(doc, index) {
    return _c('el-row', {
      key: doc.idDocument + index,
      staticClass: "entrada"
    }, [_c('el-col', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "span": 4
      }
    }, [(_vm.filteredDocuments[index]) ? _c('span', [_c('a', {
      attrs: {
        "href": _vm.filteredDocuments[index].url,
        "target": "blank"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-document",
        "circle": ""
      }
    })], 1)]) : _c('span', [_c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "el-icon-close",
        "circle": ""
      }
    })], 1)]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n            " + _vm._s(doc.documentName) + "\n          ")]), _vm._v(" "), (_vm.previousDocuments[index]) ? _c('span', [_c('br'), _c('br'), _vm._v(" "), _c('el-tree', {
      staticStyle: {
        "color": "#1f8ef0",
        "margin-left": "50px"
      },
      attrs: {
        "data": _vm.previousDocuments[index]
      },
      on: {
        "node-click": _vm.openNodeUrl
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveDocumentation
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.closeDocumentation
    }
  }, [_vm._v("Cancelar")])])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Operaciones de ' + _vm.company.companyName,
      "visible": _vm.showModalOperations,
      "width": "90%",
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalOperations = $event
      },
      "close": function($event) {
        _vm.showModalOperations = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filtersOperations[2].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersOperations[2], "value", $$v)
      },
      expression: "filtersOperations[2].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.statusId,
      attrs: {
        "value": item.statusId,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "8px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "OC"
    },
    model: {
      value: (_vm.filtersOperations[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersOperations[0], "value", $$v)
      },
      expression: "filtersOperations[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 10
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filtersOperations[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersOperations[1], "value", $$v)
      },
      expression: "filtersOperations[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.company.operations,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      },
      "filters": _vm.filtersOperations
    }
  }, [_vm._l((_vm.titlesOperations), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PDF"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" Ver\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.getStatusName(scope.row.statusId)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrder)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 2)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeOperations
    }
  }, [_vm._v("Aceptar")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "users__modal-mobile",
    attrs: {
      "id": "dialogUsuarioAsociado",
      "title": 'Usuarios asociados de: ' + _vm.company.companyName,
      "visible": _vm.showModalAssociatedUsers,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalAssociatedUsers = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {}, [_c('data-tables', {
    attrs: {
      "data": _vm.company.users,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      },
      "filters": _vm.filtersAssociatedUsers
    }
  }, _vm._l((_vm.titlesAssociatedUsers), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeAssociatedUsers
    }
  }, [_vm._v("Aceptar")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Documentación de ' + _vm.company.companyName,
      "visible": _vm.showModalDocumentRecord,
      "width": "40%",
      "lock-scroll": true,
      "before-close": _vm.closeDocumentRecord
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDocumentRecord = $event
      }
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {}, [_c('data-tables', {
    attrs: {
      "data": _vm.company.users,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      },
      "filters": _vm.filtersDocumentRecord
    }
  }, _vm._l((_vm.titlesAssociatedUsers), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeDocumentRecord
    }
  }, [_vm._v("Aceptar")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.goToNewProv()
      }
    }
  }, [_vm._v("Agregar por país")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1%"
    }
  }, [_c('countries-group', {
    attrs: {
      "filter": _vm.filters[2]
    },
    on: {
      "update-filter": _vm.updateFilter
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar",
      "clearable": ""
    },
    on: {
      "blur": function($event) {
        _vm.filters[0].value = _vm.dummyFilter
      },
      "clear": function($event) {
        _vm.filters[0].value = _vm.dummyFilter
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[0].value = _vm.dummyFilter
      }
    },
    model: {
      value: (_vm.dummyFilter),
      callback: function($$v) {
        _vm.dummyFilter = $$v
      },
      expression: "dummyFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.newProvFlags === true) ? _c('el-col', {
    staticClass: "flags__container",
    attrs: {
      "span": 6
    }
  }, [(!_vm.paramErrorProv) ? _c('router-link', {
    attrs: {
      "to": "/userActivationAR"
    }
  }, [_c('el-link', {
    attrs: {
      "underline": false
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": "static/img/AR_Flag.png"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.paramErrorProv) ? _c('router-link', {
    attrs: {
      "to": "/userActivationPE"
    }
  }, [_c('el-link', {
    attrs: {
      "underline": false
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": "static/img/PE_Flag.png"
    }
  })])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProviders),
      expression: "loadingProviders"
    }],
    attrs: {
      "data": _vm.providersOrdered,
      "total": _vm.totalProviders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getProviders
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": title.sortable
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Calificación"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-rate', {
          staticStyle: {
            "float": "left"
          },
          attrs: {
            "disabled": ""
          },
          on: {
            "change": function($event) {
              return _vm.updateCalification(scope.row, false)
            }
          },
          model: {
            value: (scope.row.calification),
            callback: function($$v) {
              _vm.$set(scope.row, "calification", _vm._n($$v))
            },
            expression: "scope.row.calification"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Rubros",
      "width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro + index
          }, [_vm._v("\n                  " + _vm._s(rubro.nombre) + "\n                  "), (index + 1 < scope.row.rubros.length) ? _c('span', [_vm._v(" / ")]) : _vm._e()])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": 300
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.idCompanyStatus === '5') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-detalles-' + scope.row.cuit,
            "type": "info",
            "icon": "fas fa-user",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-detalles-' + scope.row.cuit,
            "type": "warning",
            "icon": "fas fa-user",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Usuarios asociados",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-asoc-' + scope.row.cuit,
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getAssociatedUsers(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '5' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Operaciones",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-oper-' + scope.row.cuit,
            "type": "info",
            "icon": "el-icon-tickets",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getOperations(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Operaciones",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-asoc-' + scope.row.cuit,
            "type": "primary",
            "icon": "el-icon-tickets",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getOperations(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '5' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Documentación",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-doc-' + scope.row.cuit,
            "type": "info",
            "icon": "el-icon-document",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDocumentation(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Documentación",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-doc-' + scope.row.cuit,
            "type": "success",
            "icon": "el-icon-document",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDocumentation(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '5') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Activar",
            "placement": "top"
          }
        }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "data-cy": 'btn-start-' + scope.row.cuit,
            "type": "success",
            "icon": "el-icon-right",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.startCompany(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Suspender",
            "placement": "top"
          }
        }, [(_vm.user.roles.length > 0 && _vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "data-cy": 'btn-stop-' + scope.row.cuit,
            "type": "danger",
            "icon": "el-icon-switch-button",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.stopCompany(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Comentario",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-comment-' + scope.row.cuit,
            "type": "info",
            "icon": "fa fa-comment",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.commentCompany(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 2)], 1)])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44f65ebe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AllProviders.vue
// module id = 628
// module chunks = 1